import { isTag } from 'anodum';
import { LINK_TAG, LIST_ITEM } from '../constants/editable-elements';
import hasNodeContent from '../verifiers/has-node-content';

const removeEmptyLinksFromListItem = (element) => {
  if (isTag(element, LIST_ITEM)) {
    const links = [...element.querySelectorAll(LINK_TAG)];

    links.forEach((link) => {
      if (link && !hasNodeContent(link)) {
        link.remove();
      }
    });
  }
};

export default removeEmptyLinksFromListItem;
